import { FileProcessingResult } from '@paragon/component-processor';
import { Annotation, AnnotationType, BoundingBox } from '@paragon/contract-library';

import { RenderedItem } from '../modules/annotations/paperItemTranslator';
import { showPopup } from '../store/popup';

export interface PopupOptionsMap {
  NEW_ANNOTATION_TEMPLATE: { readonly selectedAnnotations: readonly Annotation[] };
  HELP: undefined;
  MORE_OPTIONS: undefined;
  FILENAME_PROMPT: FilenamePromptOptions;
  PLACE_TEXT: undefined;
  EDIT_ANNOTATION: EditAnnotationOptions;
  FILE_MANAGER: FileProcessingResult;
  SEAL_JOB_SPECIAL: undefined;
  DOCUMENT_TOOLS: undefined;
}

export function showSaveNewAnnotationTemplatePopup(selectedAnnotations: readonly Annotation[]) {
  return showPopup('NEW_ANNOTATION_TEMPLATE', { selectedAnnotations });
}

export function showHelpPopup() {
  return showPopup('HELP');
}

export function showMoreOptionsDialog() {
  return showPopup('MORE_OPTIONS');
}

interface FilenamePromptOptions {
  readonly format: string;
  readonly action: string;
  readonly submitClickAction: (filename: string) => void;
}

export function showFilenamePrompt(options: FilenamePromptOptions) {
  return showPopup('FILENAME_PROMPT', options);
}

export function showPlaceTextPrompt() {
  return showPopup('PLACE_TEXT');
}

interface EditAnnotationOptions {
  readonly annotationBeingEdited: Annotation;
  readonly textContent: string | null;
  readonly fontSize: number | undefined;
  readonly color: string;
  readonly annotationType: AnnotationType;
  readonly annotationBoundingBox: BoundingBox;
  readonly rotation: number;
  readonly itemBeingEdited?: RenderedItem; // Not necessary for text annotations
}

export function showEditAnnotationPrompt(options: EditAnnotationOptions) {
  return showPopup('EDIT_ANNOTATION', options);
}

export function showFileManagerPopup(options: FileProcessingResult) {
  return showPopup('FILE_MANAGER', options);
}

export function showSealJobSpecialDialog() {
  return showPopup('SEAL_JOB_SPECIAL');
}
